import React from "react";
import SitePage from "../SitePage";
import { IdCard, Gift, Percent, Sparkles, ArrowRight } from "lucide-react";

const openChat = () => window.dispatchEvent(new CustomEvent("djk:open-chat"));

export default function DropClubPage() {
  const perks = [
    { icon: Percent, title: "Prezzo Club dedicato", text: "Su una selezione crescente di action figure e edizioni limitate — sconto fino al 15%." },
    { icon: Sparkles, title: "Prelazione sui drop", text: "48 ore di anticipo su ogni nuovo arrivo prima che finisca sul catalogo pubblico." },
    { icon: Gift, title: "Punti a ogni acquisto", text: "1 € speso = 1 punto. A 500 punti scatta il buono da 50 €, riscattabile su qualsiasi ordine." },
    { icon: IdCard, title: "Card digitale gratuita", text: "Numerata, con codice univoco. Ricevi il tuo QR/barcode via email subito dopo l'attivazione — la mostri in negozio dal telefono o la salvi nel Wallet." },
  ];

  return (
    <SitePage
      testId="dropclub-page"
      breadcrumb="Brand"
      breadcrumbLabel="Drop Club"
      eyebrow="MEMBERSHIP / メンバー"
      title="DAITA'N'"
      accent="CARD"
      subtitle="Il club di chi la mensola non la vede come una mensola: la vede come un altarino. Richiedi la card, entra nel drop club, ricevi i prossimi arrivi prima degli altri."
    >
      <div className="space-y-14">
        {/* Perks grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {perks.map(({ icon: Icon, title, text }) => (
            <div key={title} className="bg-zinc-900/40 border-2 border-zinc-800 p-6 hover:border-yellow-400 transition group">
              <div className="bg-yellow-400 text-black p-3 w-12 h-12 flex items-center justify-center mb-4 group-hover:scale-110 transition">
                <Icon className="w-6 h-6" strokeWidth={3} />
              </div>
              <div className="font-heading uppercase text-xl text-white mb-2">{title}</div>
              <p className="text-zinc-400 text-sm leading-relaxed">{text}</p>
            </div>
          ))}
        </div>

        {/* How it works */}
        <div className="border-l-4 border-yellow-400 pl-6">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">COME FUNZIONA</div>
          <ol className="space-y-3 text-zinc-300">
            {[
              "Richiedi la card compilando il form in Home (bastano nome, email e cellulare).",
              "Ti confermiamo l'attivazione via email/SMS e ricevi subito il tuo codice cliente digitale.",
              "Da lì in poi: prezzi Club, prelazione e punti che si accumulano da soli sul tuo account.",
            ].map((step, i) => (
              <li key={i} className="flex gap-3">
                <span className="font-mono text-yellow-400 shrink-0">0{i + 1} —</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </div>

        {/* CTA */}
        <div className="border-t-2 border-zinc-800 pt-10 text-center">
          <p className="text-zinc-500 italic mb-6 max-w-xl mx-auto">
            La card è gratuita e digitale. Nessun canone, nessuna quota annuale, niente da portarsi in tasca — solo il tuo codice cliente e quattro vantaggi veri.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href="/#newsletter" data-testid="dropclub-cta-request" className="skew-btn bg-yellow-400 text-black font-heading uppercase text-sm px-6 py-3 border-2 border-yellow-400 hover:bg-black hover:text-yellow-400 transition inline-flex items-center gap-2">
              <span>Richiedi la card <ArrowRight className="inline w-4 h-4" strokeWidth={3} /></span>
            </a>
            <button data-testid="dropclub-cta-chat" onClick={openChat} className="skew-btn border-2 border-white text-white font-heading uppercase text-sm px-6 py-3 hover:bg-white hover:text-black transition">
              <span>Ho una domanda</span>
            </button>
          </div>
        </div>
      </div>
    </SitePage>
  );
}
